var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.5241V11.9761C20 11.4418 19.9995 11.1745 19.9346 10.9259C19.877 10.7055 19.7825 10.497 19.6546 10.3086C19.5102 10.0959 19.3096 9.91962 18.9074 9.56775L14.1074 5.36775C13.3608 4.71447 12.9875 4.38799 12.5674 4.26375C12.1972 4.15427 11.8026 4.15427 11.4324 4.26375C11.0126 4.3879 10.6398 4.71406 9.89436 5.36636L5.09277 9.56775C4.69064 9.91962 4.49004 10.0959 4.3457 10.3086C4.21779 10.497 4.12255 10.7055 4.06497 10.9259C4 11.1745 4 11.4418 4 11.9761V17.5241C4 18.456 4 18.9217 4.15224 19.2893C4.35523 19.7793 4.74432 20.1692 5.23438 20.3721C5.60192 20.5244 6.06786 20.5244 6.99974 20.5244C7.93163 20.5244 8.39808 20.5244 8.76562 20.3721C9.25568 20.1692 9.64467 19.7794 9.84766 19.2894C9.9999 18.9218 10 18.4559 10 17.524V16.524C10 15.4194 10.8954 14.524 12 14.524C13.1046 14.524 14 15.4194 14 16.524V17.524C14 18.4559 14 18.9218 14.1522 19.2894C14.3552 19.7794 14.7443 20.1692 15.2344 20.3721C15.6019 20.5244 16.0679 20.5244 16.9997 20.5244C17.9316 20.5244 18.3981 20.5244 18.7656 20.3721C19.2557 20.1692 19.6447 19.7793 19.8477 19.2893C19.9999 18.9217 20 18.456 20 17.5241Z",
    stroke: "#616161",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/iconDashboard.b715fd9d54aebbf75de1582b1428835e.svg";
export { ForwardRef as ReactComponent };